import React, { Component } from "react";
import { connect } from "react-redux";

import { Spin } from "antd";
import ListPersonne from "../../components/ListPersonne";
import { columnsPro, columnsLoc } from "./columns";
import { loadProprietaires } from "../../store/actions/proprietaireAction";
import { loadLocataires } from "../../store/actions/locataireAction";

class PersonnesListe extends Component {
  state = {};

  componentDidMount() {
    this.props.proprietaire ? this.props.loadProprietaires() : this.props.loadLocataires();
  }

  render() {
    const { proprietaire, proprietaires, locataires } = this.props;

    return (
      <Spin
        size="large"
        tip="Chargement en cours..."
        spinning={proprietaire ? !proprietaires : !locataires}
      >
        <ListPersonne
          proprietaire={proprietaire}
          //listData={proprietaire ? proprietaires : locataires}
          tableOption={proprietaire ? columnsPro : columnsLoc}
          listData={
            proprietaire
              ? proprietaires &&
                proprietaires.filter((pro) => (pro.proprietaire_personne.personne_actif = true))
                             .sort((a, b) => a.proprietaire_code.localeCompare(b.proprietaire_code))
              : locataires &&
                locataires.filter((loc) => loc.locataire_personne.personne_actif === true)
                          .sort((a, b) => a.locataire_code.localeCompare(b.locataire_code))
          }
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadProprietaires: () => dispatch(loadProprietaires()),
    loadLocataires: () => dispatch(loadLocataires()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    proprietaires: state.proprietaires.data,
    locataires: state.locataires.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonnesListe);
